<section class="login-section">
    <app-login-header></app-login-header>

    <!-- Main Page Heading Start -->
    <div class="main-page-heading text-center d-none">
      <div class="row">
        <div class="col-md-12">
          <h1 class="page-heading mb-0">{{sectionTitle|translate}}</h1>
        </div>
      </div>
    </div>
    <!-- Main Page Heading End -->
    <!-- Login Form Wrapper -->
    <div class="login-form-wrapper">
        <div class="row g-0 login-form-inner">
          <div class="col-xl-8 col-lg-7">
            <div class="login-detail-content text-white p-5">
              <!-- <div class="pb-5">
                <img src="/assets/images/logo-light.png" width="250" />
              </div> -->
              <h3 class="sub-title">{{"Smarter Lending"|translate}}.</h3>
              <h2 class="title mb-5">{{"Stronger Decisions"|translate}}.</h2>
              <div class="description w-50 pb-5">
                <p>
                  {{"A powerful loan management platform built to simplify lending, automate workflows, and help you manage every stage of the loan lifecycle"|translate}}.
                </p>
                <!-- <p>
                  {{"Simply put, Lendisoft gives you the ultimate competitive advantage!"|translate}}
                </p> -->
              </div>
              <!-- Feature row -->
              <div class="row g-4 text-white">
                <div class="col-12 col-md-3 feature-col border-end">
                  <div class="feature-icon d-flex align-items-center justify-content-center rounded-circle mb-3">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3.75h7l4 4v12.5H7a2 2 0 0 1-2-2v-12.5a2 2 0 0 1 2-2Z"/><path d="M14 3.75v4h4M8.5 12h7M8.5 15.5h7"/></svg>
                  </div>
                  <p class="mb-0 fw-bold">{{"End-to-end"|translate}}<br>{{"loan management"|translate}}</p>
                </div>

                <div class="col-12 col-md-3 feature-col border-end">
                  <div class="feature-icon d-flex align-items-center justify-content-center rounded-circle mb-3">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m13.25 2.75-8 11h6l-.5 7.5 8-11h-6l.5-7.5Z"/></svg>
                  </div>
                  <p class="mb-0 fw-bold">{{"Faster decisions"|translate}} &amp;<br>{{"workflows"|translate}}</p>
                </div>

                <div class="col-12 col-md-3 feature-col">
                  <div class="feature-icon d-flex align-items-center justify-content-center rounded-circle mb-3">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 19 6v5.5c0 4.4-2.9 7.7-7 9.5-4.1-1.8-7-5.1-7-9.5V6l7-3Z"/><path d="m9 12 2 2 4-4"/></svg>
                  </div>
                  <p class="mb-0 fw-bold">{{"Secure, scalable"|translate}} &amp;<br>{{"compliant"|translate}}</p>
                </div>

              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-5">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>

    <!-- Footer Block -->
    <div class="login-footer text-center">
      <div class="row">
        <div class="col-md-12">
          &copy; {{currentYear}} {{"Lendisoft. All rights reserved."|translate}}
        </div>
      </div>
    </div>
  </section>
